export const environment = {
  production: false,
  baseUrl: 'https://talk-svc-dev.hey-kiddo.com',
  priceId: {
    '9.99': 'price_1PUDPHDmhZPf8dUXcGeYUv3i',
    '89.99': 'price_1PUDQDDmhZPf8dUXSUjWXY2w',
  },
  smartlookKey: '2b7660ba4a00add6ddf98fd451057336d7db32c8',
  revenuecatApiKey: 'rcb_sb_nMvuguxfiBqCisNGnCnnXiGGJ',
  stripePublishKey:
    'pk_test_51NNk0FDmhZPf8dUXNcIgmY2RBt6udHccfutPK1Q0j6oQBURA4bZytlwyWuxHgCy3axwu7H3gf7X9NnpNODnAroDt00hbqcwall',
  // Branch.io configuration - replace with your actual Branch.io keys
  branchKey: 'key_test_bwsdk76zOEMnvK29o1oVKimktAcOxNCI',
  branchDomain: 'fjm8d.test-app.link', // Replace with your Branch.io domain
};
